<template>
<div>
  <v-card>
    <v-card-title>
      <h3>{{guid ? 'Edycja pracownika' : 'Nowy pracownik' }}</h3>
    </v-card-title>
    <v-divider></v-divider>
    <v-container>
  <v-form
      ref="form"
      v-model="valid"
      lazy-validation
  >
    <v-text-field
        v-model="name"
        label="Imie"
        :rules="nameRules"
        required
    ></v-text-field>

    <v-text-field
        v-model="surname"
        label="Nazwisko"
        :rules="nameRules"
        required
    ></v-text-field>

    <v-text-field
        v-model="pesel"
        label="Pesel"
        :rules="peselRules"
    ></v-text-field>

    <v-text-field
        v-model="id_number"
        label="Numer dokumentu"
        :rules="idNumberRules"
    ></v-text-field>

    <v-checkbox
        v-model="foreinger"
        label="Cudzoziemiec"
        required
    ></v-checkbox>
    <v-divider></v-divider>
    <v-btn
        color="success"
        @click="submit"
    >
      Zapisz
    </v-btn>
  </v-form>
    </v-container>
  </v-card>
</div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import Workers from "@/components/document/worker/Workers"

export default {
  components: {
    Workers
  },
  props: ['worker'],
  data() {
    return {
      peselRules:[
        v => this.foreinger ? true : !!v || 'Field is required',
        v => this.foreinger ? true : (v && v.length == 11) || 'Field is required',
      ],
      idNumberRules:[
        v => !this.foreinger ? true : !!v || 'Field is required',
        v => !this.foreinger ? true : (v && v.length > 3) || 'Field is required',
      ],
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 2) || 'Field is required',
      ],
      guid: false,
      name: "",
      surname: "",
      pesel: "",
      id_number: "",
      foreinger: false,
      loading: false,
      search: "",
      valid : false
    }
  },
  computed: {},
  watch: {
    worker: function () {
      if (this.worker) {
        this.name = this.worker.name
        this.surname = this.worker.surname
        this.pesel = this.worker.pesel
        this.foreinger = this.worker.foreinger
        this.id_number = this.worker.id_number
        this.guid = this.worker.guid
      }
    }
  },
  methods: {
    submit() {
      if(!this.$refs.form.validate()){
        return Messenger.emitError("Bład walidacji danych")
      }
      let data = {
        name : this.name,
        surname : this.surname,
        pesel : this.pesel,
        foreinger : this.foreinger,
        id_number : this.id_number
      }
      if(this.guid){
        this.updateWorker(data);
      }else {
        this.addWorker(data)
      }
    },
    updateWorker(worker){
      this.$http.put('document/worker/' + this.guid, worker)
          .then(data => {
            this.$emit('updated', data.data)
            Messenger.emitSuccess("Edytowano pracownika")
          })
          .catch(() => {
            Messenger.emitError("Nie można edytować pracownika")
          })
    },
    addWorker(worker){
      this.$http.post('document/worker', worker)
          .then(data => {
            this.$emit('created', data.data)
            Messenger.emitSuccess("Utworzono pracownika")
          })
          .catch(() => {
            Messenger.emitError("Nie można utworzyć pracownika")
          })
    }
  },

}
</script>

<style scoped>

</style>
